import Crud from './crud'
import {upload_file} from '@/commons/hpod';
import { refreshResource } from '@/commons/utils';
import Vue from 'vue';
var crud = new Crud('media', 'hình ảnh');

const state = {
    ...crud.state,
    selected: {
        ID: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    upload_file({ commit }, formData) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                upload_file("files", res => {
                    commit("setLoading", { loading: false });
                    resolve(res.data ? res.data : res);
                    refreshResource();
                }, Vue.http, formData, this.state.authentication.token, 'upload');
            }, 100)
        })
    },
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};